import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`<Hi, I'm Prajjwal Datir/>`}</h1>
    <h2>{`I Can Make Websites For you :)`}</h2>
    <h5>{`I'm a CSE, pre-final year student from COEP,`}</h5>
    <h5>{`on Journey to explore Web Dev, & discover wonders of the Technology!`}</h5>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      